import LogRocket from 'logrocket'

const logRocketProject = import.meta.env.VITE_LOGROCKET_PROJECT

export const initLogRocket = init => {
  if (init && logRocketProject) {
    LogRocket.init(logRocketProject)
  }
}

export const identifyLogRocket = (init, email) => {
  if (init && logRocketProject) {
    LogRocket.identify(email, {
      email,
    })
  }
}
